import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ConfigService } from 'src/app/core/service/config.service';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { ConfirmComponent } from 'src/app/shared/actions/delete/confirm.component';
import { DeliveredAndCollectedComponent } from './delivered-and-collected/delivered-and-collected.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-master-auction-config',
  templateUrl: './app-master-auction-config.component.html'
})
export class AppMasterAuctionConfigComponent implements OnInit {
  @Input() auctionStatus: any;
  @Input() startDateTimer: any;
  @Input() endDateTimer: any;
  @Input() number: any;
  @Input() auctionData: any;
  @Input() lastbid: any;
  @Input() LastBidder: any;
  @Input() bidders: any;
  @Input() timeExtended: any;
  subscriptions: Subscription[] = [];

  @Output() reloadPage = new EventEmitter<any>();
  @Output() AuctionEnded = new EventEmitter<any>();

  showConfirmSold: boolean = false;
  loadingBtnRequest: boolean = false;
  remaining = true;
  intervalRemaining: any;
  constructor(
    private dialog: MatDialog,
    public _config: ConfigService,
    private _auctions: AuctionsService,
    public socket: SocketService) { }

  ngOnInit() {
    console.log(this.auctionData?.delivered_file);


  }



  AdminConfirmSolid() {

    const dialogRef = this.dialog.open(DeliveredAndCollectedComponent, {
      panelClass: 'customDialogStyle',
      width: '600px',
      data: { id: this.auctionData.id }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.reloadPage.emit();
      }
    })
  }

  downloadFile() {
    // const link = document.createElement('a');
    // link.setAttribute('target', '_blank');
    // link.setAttribute('href', this.auctionData?.delivered_file);
    // link.setAttribute('download', 'document.pdf');
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    fetch("https://auctiondev.mosandah.com.sa/public/uploads/default.PNG")
      .then(resp => resp.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "delivered_files";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(error => console.error(error));
  }

  getRemaining() {

    // console.log(event);

    // this.auctionData.remaining_time = event;

    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed) {
    //   this.showConfirmSold = true;
    // }
    // if (this.remaining && this.auctionData.remaining_time < 60 && this.auctionStatus == "ongoing") {
    //   this.remaining = false;
    //   this.intervalRemaining = setInterval(() => {
    //     this.socket?.socket?.emit("getRemaining", this.auctionData.id);
    //   }, 2000)



    // }

  }
  getRemainingSocket() {
    this.subscriptions.push(
      this.socket.getDataStream<string>("getRemaining" + this.auctionData.id)
        .subscribe(message => {


          this.auctionData.remaining_time = message.data.response;
          if (message.data.response == 0) {
            this.OnReload('ongoing');
          }
          if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && this.auctionData.remaining_time <= 300) {
            this.showConfirmSold = true;
          }

        })
    )
  }
  OnReload(status: string) {
    if (status == 'upcoming') {
      this.auctionStatus = 'ongoing';
      this.getRemainingSocket();
    } else {
      this.auctionStatus = 'end';
      this.AuctionEnded.emit(true);
      clearInterval(this.intervalRemaining);
    }
  }
}
